import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useConvertLoyaltyPoints = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.IConvertLoyaltyPointsRequestData): Promise<Types.IConvertLoyaltyPointsResponseData> => {
            const { data } = await send<Types.IConvertLoyaltyPointsRequestData, Types.IConvertLoyaltyPointsResponseData>({
                ID: 35781,
                responses: [35782, 35783],
                description: 'Convert loyalty points',
                errorLevel: 1,
                ...request
            });

            return data;
        }, [
            send
        ]);
};
